<nz-page-header [nzGhost]="false" class="!bg-blue-300 dark:!bg-navy-700 !sticky top-0 z-50">
	<nz-page-header-title>
		<h1 class="text-[60px] text-sky-800 dark:text-accent-light/80 mb-0">
			{{ 'users.title' | translate }}
		</h1>
		@if (_periodToShow) {
		<span class="font-poppins_bold text-sky-800 dark:text-accent-light/80">{{ 'header.period' | translate }}:
		</span>
		<span class="font-poppins_light text-sky-800 dark:text-accent-light/80">
			{{ _periodToShow }}</span>
		}
	</nz-page-header-title>
</nz-page-header>

<div class="grid gap-4 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 w-[90%] ml-auto mr-auto mb-auto">
	<div class="mt-5 card w-full h-48 m-auto rounded-xl border-none dark:bg-navy-700">
		<div class="grid grid-cols-4">
			<div class="col-span-2 text-center h-40 mt-8">
				<h3 class="text-[25px] font-poppins_light text-gray-600 dark:text-navy-100">
					{{ 'client.totals' | translate }}
					<i nz-tooltip class="text-blue-500 text-[15px]" nzTooltipTitle="{{ 'tooltip.clients_total' | translate }}"
						nzTooltipPlacement="rightBottom" nz-icon nzType="info-circle" nzTheme="outline"></i>
				</h3>
				<svg fill="currentColor" class="m-auto dark:text-accent-light/80" style="padding-top: 10px" width="75px"
					height="75px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#000000"
					stroke-width="0.00032">
					<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
					<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
					<g id="SVGRepo_iconCarrier">
						<title>users</title>
						<path
							d="M16 21.916c-4.797 0.020-8.806 3.369-9.837 7.856l-0.013 0.068c-0.011 0.048-0.017 0.103-0.017 0.16 0 0.414 0.336 0.75 0.75 0.75 0.357 0 0.656-0.25 0.731-0.585l0.001-0.005c0.875-3.885 4.297-6.744 8.386-6.744s7.511 2.859 8.375 6.687l0.011 0.057c0.076 0.34 0.374 0.59 0.732 0.59 0 0 0.001 0 0.001 0h-0c0.057-0 0.112-0.007 0.165-0.019l-0.005 0.001c0.34-0.076 0.59-0.375 0.59-0.733 0-0.057-0.006-0.112-0.018-0.165l0.001 0.005c-1.045-4.554-5.055-7.903-9.849-7.924h-0.002zM9.164 10.602c0 0 0 0 0 0 2.582 0 4.676-2.093 4.676-4.676s-2.093-4.676-4.676-4.676c-2.582 0-4.676 2.093-4.676 4.676v0c0.003 2.581 2.095 4.673 4.675 4.676h0zM9.164 2.75c0 0 0 0 0 0 1.754 0 3.176 1.422 3.176 3.176s-1.422 3.176-3.176 3.176c-1.754 0-3.176-1.422-3.176-3.176v0c0.002-1.753 1.423-3.174 3.175-3.176h0zM22.926 10.602c2.582 0 4.676-2.093 4.676-4.676s-2.093-4.676-4.676-4.676c-2.582 0-4.676 2.093-4.676 4.676v0c0.003 2.581 2.095 4.673 4.675 4.676h0zM22.926 2.75c1.754 0 3.176 1.422 3.176 3.176s-1.422 3.176-3.176 3.176c-1.754 0-3.176-1.422-3.176-3.176v0c0.002-1.753 1.423-3.174 3.176-3.176h0zM30.822 19.84c-0.878-3.894-4.308-6.759-8.406-6.759-0.423 0-0.839 0.031-1.246 0.089l0.046-0.006c-0.049 0.012-0.092 0.028-0.133 0.047l0.004-0.002c-0.751-2.129-2.745-3.627-5.089-3.627-2.334 0-4.321 1.485-5.068 3.561l-0.012 0.038c-0.017-0.004-0.030-0.014-0.047-0.017-0.359-0.053-0.773-0.084-1.195-0.084-0.002 0-0.005 0-0.007 0h0c-4.092 0.018-7.511 2.874-8.392 6.701l-0.011 0.058c-0.011 0.048-0.017 0.103-0.017 0.16 0 0.414 0.336 0.75 0.75 0.75 0.357 0 0.656-0.25 0.731-0.585l0.001-0.005c0.737-3.207 3.56-5.565 6.937-5.579h0.002c0.335 0 0.664 0.024 0.985 0.070l-0.037-0.004c-0.008 0.119-0.036 0.232-0.036 0.354 0.006 2.987 2.429 5.406 5.417 5.406s5.411-2.419 5.416-5.406v-0.001c0-0.12-0.028-0.233-0.036-0.352 0.016-0.002 0.031 0.005 0.047 0.001 0.294-0.044 0.634-0.068 0.98-0.068 0.004 0 0.007 0 0.011 0h-0.001c3.379 0.013 6.203 2.371 6.93 5.531l0.009 0.048c0.076 0.34 0.375 0.589 0.732 0.59h0c0.057-0 0.112-0.007 0.165-0.019l-0.005 0.001c0.34-0.076 0.59-0.375 0.59-0.733 0-0.057-0.006-0.112-0.018-0.165l0.001 0.005zM16 18.916c-0 0-0 0-0.001 0-2.163 0-3.917-1.753-3.917-3.917s1.754-3.917 3.917-3.917c2.163 0 3.917 1.754 3.917 3.917 0 0 0 0 0 0.001v-0c-0.003 2.162-1.754 3.913-3.916 3.916h-0z">
						</path>
					</g>
				</svg>
			</div>
			<div class="text-center h-40 mt-8 col-span-2">
				@if (_totalCounters !== null) {
				<h3 class="text-[40px] font-poppins_semibold text-gray-600 dark:text-navy-100">
					{{ _totalCounters | number: '' : 'it' }}
				</h3>
				<!-- <h3 class="text-[15px] font-poppins_light text-gray-600 dark:text-navy-100  ">{{_nDevicesInDay | number:'':'it'}} - {{'overview.device_at_day' | translate}}</h3> -->
				} @else {
				<!-- <div class="small-loader"></div> -->
				<svg class="w-[100px] m-auto" id="Livello_1" data-name="Livello 1" xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 195.09 151">
					<path
						d="m63.09,144.99v-46.63l-10.68,6.17c-.48.27-1.09.11-1.36-.37-.27-.48-.11-1.08.36-1.36l11.68-6.74v-18.43l-18.8,10.85c-.48.27-1.09.11-1.36-.37-.27-.48-.11-1.08.36-1.36l19.8-11.43v-26.17l-45.1,26.04c-.88.51-1.18,1.64-.68,2.52,0,0,0,0,0,0l39.66,68.69c.51.88,1.64,1.18,2.52.68,0,0,0,0,0,0l3.6-2.08h0Zm.15,2.22l-2.75,1.59c-1.84,1.06-4.19.43-5.25-1.41L15.58,78.71c-1.06-1.84-.43-4.19,1.41-5.25l46.1-26.62v-12.84c0-2.76,2.24-5,5-5h82c2.76,0,5,2.24,5,5v112c0,2.76-2.24,5-5,5h-82c-2.29,0-4.29-1.56-4.85-3.78ZM173.09,6V1c0-.55.45-1,1-1s1,.45,1,1v5h5c.55,0,1,.45,1,1s-.45,1-1,1h-5v5c0,.55-.45,1-1,1s-1-.45-1-1v-5h-5c-.55,0-1-.45-1-1s.45-1,1-1h5Zm14,27v-5c0-.55.45-1,1-1s1,.45,1,1v5h5c.55,0,1,.45,1,1s-.45,1-1,1h-5v5c0,.55-.45,1-1,1s-1-.45-1-1v-5h-5c-.55,0-1-.45-1-1s.45-1,1-1h5Zm-20,1c-2.76,0-5-2.24-5-5s2.24-5,5-5,5,2.24,5,5-2.24,5-5,5Zm0-2c1.66,0,3-1.34,3-3s-1.34-3-3-3-3,1.34-3,3,1.34,3,3,3Zm-67.58,38.89c-.5.24-1.12.06-1.39-.4-.26-.46-.07-1.04.44-1.28l.38-.18c.17-.08.31-.15.45-.21.36-.17.73-.32,1.11-.47,2.32-.87,5.26-1.35,9.5-1.35,3.24,0,5.88.29,7.97.81,1.64.4,2.86.93,3.64,1.5.45.32.52.92.18,1.33-.35.41-1,.48-1.44.16-.55-.4-1.52-.82-2.91-1.16-1.9-.47-4.36-.74-7.43-.74-3.99,0-6.67.44-8.73,1.21-.33.12-.64.25-.97.41-.13.06-.26.12-.41.19l-.39.19h0Zm-21.42,39.11h62c.55,0,1,.45,1,1s-.45,1-1,1h-62c-.55,0-1-.45-1-1s.45-1,1-1Zm0,20h62c.55,0,1,.45,1,1s-.45,1-1,1h-62c-.55,0-1-.45-1-1s.45-1,1-1Zm0-40h62c.55,0,1,.45,1,1s-.45,1-1,1h-62c-.55,0-1-.45-1-1s.45-1,1-1Zm-10-59c-1.66,0-3,1.34-3,3v112c0,1.66,1.34,3,3,3h82c1.66,0,3-1.34,3-3V34c0-1.66-1.34-3-3-3h-82Zm18.47,18.85c-.47-.29-.61-.91-.31-1.38.29-.47.91-.61,1.38-.31l10,6.31c.47.29.61.91.31,1.38-.07.12-.17.22-.29.3l-10,6.69c-.46.3-1.08.17-1.38-.3-.29-.45-.17-1.06.27-1.36l8.72-5.83s-8.7-5.49-8.7-5.49Zm45.05.05l-8.84,5.3,8.86,5.63c.47.3.6.91.31,1.38-.3.47-.91.6-1.38.31h0l-10.23-6.5c-.47-.3-.6-.91-.31-1.38.08-.13.2-.24.33-.32l10.23-6.14c.47-.28,1.09-.13,1.37.34.28.47.13,1.09-.34,1.37h0ZM.03,76.97c.14-.53.69-.85,1.22-.71,0,0,0,0,0,0l7.73,2.07c.53.14.85.69.71,1.22-.14.53-.69.85-1.22.71,0,0,0,0,0,0l-7.73-2.07c-.53-.14-.85-.69-.71-1.22,0,0,0,0,0,0Zm15.71-16.71c.53-.14,1.08.17,1.22.71,0,0,0,0,0,0l2.07,7.73c.13.54-.2,1.08-.74,1.21-.52.12-1.04-.18-1.19-.69l-2.07-7.73c-.14-.53.17-1.08.71-1.22Zm-12.26,3.45c.39-.39,1.02-.39,1.41,0l7.07,7.07c.38.4.36,1.04-.04,1.41-.38.36-.98.36-1.37,0l-7.07-7.07c-.39-.39-.39-1.02,0-1.41,0,0,0,0,0,0Z"
						style="fill: #dcdfe6; stroke-width: 0px" />
				</svg>
				<span class="font-poppins_light text-gray-600 dark:text-navy-100">No Data</span>
				}
			</div>
		</div>
	</div>
	@if (_verifiedCounters != 0) {
	<div class="mt-5 card w-full h-48 m-auto rounded-xl border-none dark:bg-navy-700">
		<div class="grid grid-cols-4">
			<div class="col-span-2 text-center h-40 mt-8">
				<h3 class="text-[25px] font-poppins_light text-gray-600 dark:text-navy-100">
					{{ 'client.verified' | translate }}
					<i nz-tooltip class="text-blue-500 text-[15px]" nzTooltipTitle="{{ 'tooltip.clients_verified' | translate }}"
						nzTooltipPlacement="rightBottom" nz-icon nzType="info-circle" nzTheme="outline"></i>
				</h3>
				<!-- <svg fill="currentColor" class="m-auto dark:text-accent-light/80" _ngcontent-xhb-c197="" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width: 85px;"><path _ngcontent-xhb-c197="" d="M12,1.5A10.5,10.5,0,1,0,22.5,12,10.51148,10.51148,0,0,0,12,1.5Zm0,20A9.5,9.5,0,1,1,21.5,12,9.51081,9.51081,0,0,1,12,21.5ZM16.5,12a.49971.49971,0,0,1-.5.5H12a.49971.49971,0,0,1-.5-.5V6a.5.5,0,0,1,1,0v5.5H16A.49971.49971,0,0,1,16.5,12Z"></path></svg> -->
				<svg fill="currentColor" class="m-auto dark:text-accent-light/80" id="Livello_1" data-name="Livello 1"
					xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 219.89" style="width: 65px; padding-top: 10px">
					<path stroke="currentColor"
						d="M5.5,93.41c0-33.4,0-50.1,3.94-55.71,3.94-5.62,19.64-10.99,51.05-21.74l5.98-2.05c16.37-5.6,24.55-8.4,33.03-8.4s16.66,2.8,33.03,8.4l5.98,2.05c31.4,10.75,47.1,16.12,51.05,21.74,3.94,5.62,3.94,22.32,3.94,55.71v16.45c0,58.89-44.27,87.46-72.05,99.6-7.53,3.29-11.3,4.94-21.95,4.94s-14.41-1.65-21.95-4.94C49.77,197.32,5.5,168.74,5.5,109.85v-16.45Z"
						style="
								fill: none;
								isolation: isolate;
								stroke-miterlimit: 133.33;
								stroke-width: 9px;
							" />
					<path
						d="M83.18,43.83c-17.08,0-30.93,13.85-30.93,30.93s13.85,30.93,30.93,30.93,30.93-13.85,30.93-30.93c-.02-17.08-13.86-30.91-30.93-30.93ZM83.18,100.08c-13.98,0-25.31-11.33-25.31-25.31s11.33-25.31,25.31-25.31,25.31,11.33,25.31,25.31c-.02,13.97-11.34,25.29-25.31,25.31ZM41,159.13v-11.25c.02-13.97,11.34-25.29,25.31-25.31h33.75c13.97.02,25.29,11.34,25.31,25.31v11.25c0,1.55-1.26,2.81-2.81,2.81s-2.81-1.26-2.81-2.81v-11.25c-.01-10.87-8.82-19.67-19.68-19.68h-33.75c-10.87.01-19.67,8.82-19.68,19.68v11.25c0,1.55-1.26,2.81-2.81,2.81s-2.81-1.26-2.81-2.81ZM114.12,102.89c0-1.55,1.26-2.81,2.81-2.81h0c13.98,0,25.31-11.33,25.31-25.31s-11.33-25.31-25.31-25.31c-1.55,0-2.81-1.26-2.81-2.81s1.26-2.81,2.81-2.81c17.08,0,30.93,13.85,30.93,30.93s-13.85,30.93-30.93,30.93c-1.55,0-2.81-1.26-2.81-2.81h0ZM153.49,159.13v-11.25c-.01-10.87-8.82-19.67-19.68-19.68-1.55,0-2.81-1.26-2.81-2.81s1.26-2.81,2.81-2.81c13.97.02,25.29,11.34,25.31,25.31v11.25c0,1.55-1.26,2.81-2.81,2.81s-2.81-1.26-2.81-2.81Z"
						fill="currentColor" style="stroke-width: 0px" />
				</svg>
			</div>
			<div class="text-center h-40 mt-8 col-span-2">
				@if (_verifiedCounters !== null) {
				<h3 class="text-[40px] font-poppins_semibold text-gray-600 dark:text-navy-100">
					{{ _verifiedCounters | number: '' : 'it'
					}}<span class="font-thin text-sm"></span>
				</h3>
				<!-- <h3 class="text-[15px] font-poppins_light text-gray-600 dark:text-navy-100">{{_nHoursInDays}} - {{'overview.average_usage' | translate}}</h3> -->
				} @else {
				<!-- <div class="small-loader"></div> -->
				<svg class="w-[100px] m-auto" id="Livello_1" data-name="Livello 1" xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 195.09 151">
					<path
						d="m63.09,144.99v-46.63l-10.68,6.17c-.48.27-1.09.11-1.36-.37-.27-.48-.11-1.08.36-1.36l11.68-6.74v-18.43l-18.8,10.85c-.48.27-1.09.11-1.36-.37-.27-.48-.11-1.08.36-1.36l19.8-11.43v-26.17l-45.1,26.04c-.88.51-1.18,1.64-.68,2.52,0,0,0,0,0,0l39.66,68.69c.51.88,1.64,1.18,2.52.68,0,0,0,0,0,0l3.6-2.08h0Zm.15,2.22l-2.75,1.59c-1.84,1.06-4.19.43-5.25-1.41L15.58,78.71c-1.06-1.84-.43-4.19,1.41-5.25l46.1-26.62v-12.84c0-2.76,2.24-5,5-5h82c2.76,0,5,2.24,5,5v112c0,2.76-2.24,5-5,5h-82c-2.29,0-4.29-1.56-4.85-3.78ZM173.09,6V1c0-.55.45-1,1-1s1,.45,1,1v5h5c.55,0,1,.45,1,1s-.45,1-1,1h-5v5c0,.55-.45,1-1,1s-1-.45-1-1v-5h-5c-.55,0-1-.45-1-1s.45-1,1-1h5Zm14,27v-5c0-.55.45-1,1-1s1,.45,1,1v5h5c.55,0,1,.45,1,1s-.45,1-1,1h-5v5c0,.55-.45,1-1,1s-1-.45-1-1v-5h-5c-.55,0-1-.45-1-1s.45-1,1-1h5Zm-20,1c-2.76,0-5-2.24-5-5s2.24-5,5-5,5,2.24,5,5-2.24,5-5,5Zm0-2c1.66,0,3-1.34,3-3s-1.34-3-3-3-3,1.34-3,3,1.34,3,3,3Zm-67.58,38.89c-.5.24-1.12.06-1.39-.4-.26-.46-.07-1.04.44-1.28l.38-.18c.17-.08.31-.15.45-.21.36-.17.73-.32,1.11-.47,2.32-.87,5.26-1.35,9.5-1.35,3.24,0,5.88.29,7.97.81,1.64.4,2.86.93,3.64,1.5.45.32.52.92.18,1.33-.35.41-1,.48-1.44.16-.55-.4-1.52-.82-2.91-1.16-1.9-.47-4.36-.74-7.43-.74-3.99,0-6.67.44-8.73,1.21-.33.12-.64.25-.97.41-.13.06-.26.12-.41.19l-.39.19h0Zm-21.42,39.11h62c.55,0,1,.45,1,1s-.45,1-1,1h-62c-.55,0-1-.45-1-1s.45-1,1-1Zm0,20h62c.55,0,1,.45,1,1s-.45,1-1,1h-62c-.55,0-1-.45-1-1s.45-1,1-1Zm0-40h62c.55,0,1,.45,1,1s-.45,1-1,1h-62c-.55,0-1-.45-1-1s.45-1,1-1Zm-10-59c-1.66,0-3,1.34-3,3v112c0,1.66,1.34,3,3,3h82c1.66,0,3-1.34,3-3V34c0-1.66-1.34-3-3-3h-82Zm18.47,18.85c-.47-.29-.61-.91-.31-1.38.29-.47.91-.61,1.38-.31l10,6.31c.47.29.61.91.31,1.38-.07.12-.17.22-.29.3l-10,6.69c-.46.3-1.08.17-1.38-.3-.29-.45-.17-1.06.27-1.36l8.72-5.83s-8.7-5.49-8.7-5.49Zm45.05.05l-8.84,5.3,8.86,5.63c.47.3.6.91.31,1.38-.3.47-.91.6-1.38.31h0l-10.23-6.5c-.47-.3-.6-.91-.31-1.38.08-.13.2-.24.33-.32l10.23-6.14c.47-.28,1.09-.13,1.37.34.28.47.13,1.09-.34,1.37h0ZM.03,76.97c.14-.53.69-.85,1.22-.71,0,0,0,0,0,0l7.73,2.07c.53.14.85.69.71,1.22-.14.53-.69.85-1.22.71,0,0,0,0,0,0l-7.73-2.07c-.53-.14-.85-.69-.71-1.22,0,0,0,0,0,0Zm15.71-16.71c.53-.14,1.08.17,1.22.71,0,0,0,0,0,0l2.07,7.73c.13.54-.2,1.08-.74,1.21-.52.12-1.04-.18-1.19-.69l-2.07-7.73c-.14-.53.17-1.08.71-1.22Zm-12.26,3.45c.39-.39,1.02-.39,1.41,0l7.07,7.07c.38.4.36,1.04-.04,1.41-.38.36-.98.36-1.37,0l-7.07-7.07c-.39-.39-.39-1.02,0-1.41,0,0,0,0,0,0Z"
						style="fill: #dcdfe6; stroke-width: 0px" />
				</svg>
				<span class="font-poppins_light text-gray-600 dark:text-navy-100">No Data</span>
				}
			</div>
		</div>
	</div>
	} @else {
	<div class="mt-5 card w-full h-48 m-auto rounded-xl border-none dark:bg-navy-700">
		<div class="grid grid-cols-1">
			<div class="col-span-2 text-center h-40 mt-8">
				<h3 class="text-[25px] font-poppins_light text-gray-600 dark:text-navy-100">
					{{ 'client.verified' | translate }}
					<i nz-tooltip class="text-blue-500 text-[15px]" nzTooltipTitle="{{ 'tooltip.clients_verified' | translate }}"
						nzTooltipPlacement="rightBottom" nz-icon nzType="info-circle" nzTheme="outline"></i>
				</h3>
				<!-- <svg fill="currentColor" class="m-auto dark:text-accent-light/80" _ngcontent-xhb-c197="" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width: 85px;"><path _ngcontent-xhb-c197="" d="M12,1.5A10.5,10.5,0,1,0,22.5,12,10.51148,10.51148,0,0,0,12,1.5Zm0,20A9.5,9.5,0,1,1,21.5,12,9.51081,9.51081,0,0,1,12,21.5ZM16.5,12a.49971.49971,0,0,1-.5.5H12a.49971.49971,0,0,1-.5-.5V6a.5.5,0,0,1,1,0v5.5H16A.49971.49971,0,0,1,16.5,12Z"></path></svg> -->
				<svg fill="currentColor" class="m-auto dark:text-accent-light/80" id="Livello_1" data-name="Livello 1"
					xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 219.89" style="width: 65px; padding-top: 10px">
					<path stroke="currentColor"
						d="M5.5,93.41c0-33.4,0-50.1,3.94-55.71,3.94-5.62,19.64-10.99,51.05-21.74l5.98-2.05c16.37-5.6,24.55-8.4,33.03-8.4s16.66,2.8,33.03,8.4l5.98,2.05c31.4,10.75,47.1,16.12,51.05,21.74,3.94,5.62,3.94,22.32,3.94,55.71v16.45c0,58.89-44.27,87.46-72.05,99.6-7.53,3.29-11.3,4.94-21.95,4.94s-14.41-1.65-21.95-4.94C49.77,197.32,5.5,168.74,5.5,109.85v-16.45Z"
						style="
								fill: none;
								isolation: isolate;
								stroke-miterlimit: 133.33;
								stroke-width: 9px;
							" />
					<path
						d="M83.18,43.83c-17.08,0-30.93,13.85-30.93,30.93s13.85,30.93,30.93,30.93,30.93-13.85,30.93-30.93c-.02-17.08-13.86-30.91-30.93-30.93ZM83.18,100.08c-13.98,0-25.31-11.33-25.31-25.31s11.33-25.31,25.31-25.31,25.31,11.33,25.31,25.31c-.02,13.97-11.34,25.29-25.31,25.31ZM41,159.13v-11.25c.02-13.97,11.34-25.29,25.31-25.31h33.75c13.97.02,25.29,11.34,25.31,25.31v11.25c0,1.55-1.26,2.81-2.81,2.81s-2.81-1.26-2.81-2.81v-11.25c-.01-10.87-8.82-19.67-19.68-19.68h-33.75c-10.87.01-19.67,8.82-19.68,19.68v11.25c0,1.55-1.26,2.81-2.81,2.81s-2.81-1.26-2.81-2.81ZM114.12,102.89c0-1.55,1.26-2.81,2.81-2.81h0c13.98,0,25.31-11.33,25.31-25.31s-11.33-25.31-25.31-25.31c-1.55,0-2.81-1.26-2.81-2.81s1.26-2.81,2.81-2.81c17.08,0,30.93,13.85,30.93,30.93s-13.85,30.93-30.93,30.93c-1.55,0-2.81-1.26-2.81-2.81h0ZM153.49,159.13v-11.25c-.01-10.87-8.82-19.67-19.68-19.68-1.55,0-2.81-1.26-2.81-2.81s1.26-2.81,2.81-2.81c13.97.02,25.29,11.34,25.31,25.31v11.25c0,1.55-1.26,2.81-2.81,2.81s-2.81-1.26-2.81-2.81Z"
						fill="currentColor" style="stroke-width: 0px" />
				</svg>
			</div>
		</div>
	</div>
	}
</div>
<div></div>
<div class="w-[90%] m-auto card rounded-xl border-none mt-5 dark:bg-navy-800 dark:text-[#818cf8]">
	<div class="text-right m-6 flex items-center justify-end space-x-4">
		<div class="flex items-center space-x-2">
			<span class="font-poppins_light text-sky-800 dark:text-accent-light/80">
				{{
				'table.search' | translate
				}}
			</span>
			<nz-input-group [nzSuffix]="searchIcon">
				<input nz-input type="text" [nz-tooltip]="'table.searchTooltip' | translate" [(ngModel)]="_searchTerm"
					(keyup.enter)="search()" />
			</nz-input-group>

			<ng-template #searchIcon>
				<span nz-icon nzType="search" (click)="search()" class="cursor-pointer"></span>
			</ng-template>

		</div>
		<div class="flex items-center space-x-2">
			<span class="font-poppins_light text-sky-800 dark:text-accent-light/80">{{
				'table.filter_strategy' | translate
				}}</span>
			<nz-select class="min-w-[180px]" [(ngModel)]="_strategyFilter" (ngModelChange)="onStrategyFilterChange($event)">
				<nz-option nzValue="all" [nzLabel]="'table.all_strategies' | translate"></nz-option>
				<nz-option nzValue="passpoint" [nzLabel]="'table.passpoint_only' | translate"></nz-option>
				<nz-option nzValue="captive" [nzLabel]="'table.captive_only' | translate"></nz-option>
			</nz-select>
		</div>
		@if (Helpers.getRoleFromLS() != 'Viewer') {
		<div class="flex items-center cursor-pointer" (click)="exportToCSV()">
			<span class="font-poppins_light text-sky-800 dark:text-accent-light/80 ml-2">Download CSV</span>
			<svg class="ml-2" height="30px" width="30px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg"
				xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.00 512.00" xml:space="preserve" fill="#2096f3"
				stroke="#2096f3" stroke-width="0.00512" transform="rotate(0)matrix(1, 0, 0, 1, 0, 0)">
				<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
				<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC"
					stroke-width="3.072"></g>
				<g id="SVGRepo_iconCarrier">
					<style type="text/css">
						.st0 {
							fill: #2096f3;
						}
					</style>
					<g>
						<path class="st0"
							d="M378.409,0H208.294h-13.176l-9.314,9.315L57.017,138.101l-9.314,9.315v13.176v265.513 c0,47.36,38.528,85.896,85.895,85.896h244.811c47.361,0,85.888-38.535,85.888-85.896V85.896C464.297,38.528,425.77,0,378.409,0z M432.493,426.104c0,29.877-24.214,54.091-54.084,54.091H133.598c-29.877,0-54.091-24.214-54.091-54.091V160.592h83.717 c24.884,0,45.07-20.179,45.07-45.071V31.804h170.114c29.87,0,54.084,24.214,54.084,54.091V426.104z">
						</path>
						<path class="st0"
							d="M180.296,296.668l-4.846-0.67c-10.63-1.487-14.265-4.978-14.265-10.104c0-5.78,4.309-9.817,12.383-9.817 c5.653,0,11.305,1.62,15.745,3.764c1.886,0.942,3.903,1.487,5.789,1.487c4.845,0,8.612-3.63,8.612-8.616 c0-3.226-1.481-5.921-4.71-7.939c-5.384-3.372-15.476-6.06-25.572-6.06c-19.781,0-32.436,11.171-32.436,27.998 c0,16.15,10.232,24.898,28.938,27.454l4.846,0.67c10.903,1.48,14.129,4.846,14.129,10.229c0,6.326-5.247,10.766-14.939,10.766 c-6.727,0-12.111-1.745-19.645-5.921c-1.616-0.942-3.634-1.62-5.788-1.62c-5.115,0-8.885,3.91-8.885,8.756 c0,3.226,1.616,6.326,4.713,8.344c6.054,3.764,15.878,7.8,28.798,7.8c23.823,0,35.934-12.24,35.934-28.795 C209.097,307.84,199.273,299.356,180.296,296.668z">
						</path>
						<path class="st0"
							d="M281.108,259.382c-4.577,0-7.939,2.43-9.556,7.674l-16.69,54.51h-0.402l-17.634-54.51 c-1.745-5.244-4.978-7.674-9.551-7.674c-5.653,0-9.692,4.176-9.692,9.287c0,1.347,0.269,2.834,0.67,4.175l23.286,68.104 c2.96,8.477,6.727,11.57,12.652,11.57c5.785,0,9.555-3.093,12.516-11.57l23.282-68.104c0.406-1.341,0.674-2.828,0.674-4.175 C290.664,263.558,286.76,259.382,281.108,259.382z">
						</path>
						<path class="st0"
							d="M364.556,300.836h-18.841c-5.114,0-8.344,3.1-8.344,7.806c0,4.713,3.23,7.814,8.344,7.814h6.193 c0.538,0,0.803,0.258,0.803,0.803c0,3.505-0.265,6.598-1.075,9.014c-1.882,5.796-7.67,9.426-14.669,9.426 c-7.943,0-12.921-3.903-14.939-10.096c-1.075-3.365-1.48-7.8-1.48-19.648c0-11.842,0.405-16.15,1.48-19.516 c2.018-6.325,6.867-10.228,14.67-10.228c5.924,0,10.362,1.885,13.859,6.724c2.695,3.777,5.387,4.852,8.749,4.852 c4.981,0,9.021-3.638,9.021-8.888c0-2.151-0.674-4.035-1.752-5.921c-4.842-8.204-15.071-14.264-29.877-14.264 c-16.287,0-28.935,7.408-33.644,22.204c-2.022,6.466-2.559,11.576-2.559,25.038c0,13.454,0.538,18.573,2.559,25.031 c4.709,14.802,17.357,22.204,33.644,22.204c16.286,0,28.668-8.204,33.374-22.881c1.617-5.111,2.29-12.645,2.29-20.716v-0.95 C372.362,303.664,369.538,300.836,364.556,300.836z">
						</path>
					</g>
				</g>
			</svg>
		</div>
		}
		@if (
		hasData('first_name') ||
		hasData('last_name') ||
		hasData('email') ||
		hasData('phone_number')
		) {
		<span class="mx-4">|</span>
		<div class="flex items-center">
			<span class="font-poppins_light text-sky-800 dark:text-accent-light/80 mr-2">
				Privacy Mode</span>
			<label class="switch">
				<input type="checkbox" (change)="toggleDetailsFromBlur()" [checked]="!_showDetailsFromBlur" />
				<span class="slider round"></span>
			</label>
		</div>
		}
	</div>
	<nz-table nzTemplateMode class="rounded-lg bg-white dark:border-navy-700 dark:bg-navy-800 text-center"
		nzShowSizeChanger [nzScroll]="{ x: '1150px' }" [nzData]="_filteredClients" [nzFrontPagination]="false"
		[nzLoading]="_loading" [nzTotal]="_totalItems" [nzPageSize]="_paging.pageSize" [nzPageIndex]="_paging.pageIndex"
		(nzQueryParams)="onQueryParamsChange($event)">
		<thead nzSingleSort>
			<tr class="dark:hover:bg-navy-450">
				@if (hasData('first_name')) {
				<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.first_name' | translate }}
				</th>
				}
				@if (hasData('last_name')) {
				<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.last_name' | translate }}
				</th>
				}
				@if (hasData('phone_number')) {
				<th class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.phone_number' | translate }}
				</th>
				}
				@if (hasData('email')) {
				<th nzWidth="250px" class="dark:bg-navy-800 dark:text-[#818cf8] w-auto">
					{{ 'table.email' | translate }}
				</th>
				}
				@if (_marketingConsentCounters != 0) {
				<th nzWidth="100px" class="dark:bg-navy-800 dark:text-[#818cf8] w-auto">
					{{ 'table.marketing_consent' | translate }}
				</th>
				}
				@if (_profileConsentCounters != 0) {
				<th nzWidth="120px" class="dark:bg-navy-800 dark:text-[#818cf8] w-auto">
					{{ 'table.profile_consents' | translate }}
				</th>
				}
				@if (hasData('last_update')) {
				<th nzAlign="center" class="dark:bg-navy-800 dark:text-[#818cf8]" [nzSortFn]="true" nzColumnKey="last_update">
					{{ 'table.last_update' | translate }}
				</th>
				}
				@if (hasData('registered_at')) {
				<th nzWidth="200px" nzAlign="center" class="dark:bg-navy-800 dark:text-[#818cf8]" [nzSortFn]="true"
					nzColumnKey="registered_at">
					{{ 'table.registered_at' | translate }}
				</th>
				}
				@if (hasData('strategy')) {
				<th nzAlign="center" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.strategy' | translate }}
				</th>
				}

				@if (_verifiedCounters != 0) {
				<th nzWidth="100px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.verified' | translate }}
				</th>
				}
				@if (hasData('verified')) {
				<th nzAlign="center" nzWidth="100px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.show_sessions' | translate }}
				</th>
				}
			</tr>
		</thead>
		<tbody>
			@for (row of _filteredClients; track $index) {
			<tr class="bg-white dark:border-navy-700 dark:bg-navy-800 dark:text-navy-100 dark:hover:bg-navy-450">
				@if (hasData('first_name')) {
				<td nzLeft [ngClass]="{ 'blur-text': !_showDetailsFromBlur }">
					{{ row.first_name }}
				</td>
				}
				@if (hasData('last_name')) {
				<td nzLeft [ngClass]="{ 'blur-text': !_showDetailsFromBlur }">
					{{ row.last_name }}
				</td>
				}
				@if (hasData('phone_number')) {
				<td nzLeft [ngClass]="{ 'blur-text': !_showDetailsFromBlur }">
					{{ row.phone_number }}
				</td>
				}
				@if (hasData('email')) {
				<td nzLeft [ngClass]="{ 'blur-text': !_showDetailsFromBlur }">
					{{ row.email }}
				</td>
				}
				@if (_marketingConsentCounters != 0) {
				<td class="w-[50px]">
					@if (row.marketing_consent != true) {
					<div class="w-4 h-4 bg-red-500 rounded-full m-auto"></div>
					} @else {
					<div class="w-4 h-4 bg-green-500 rounded-full m-auto"></div>
					}
				</td>
				}
				@if (_profileConsentCounters != 0) {
				<td class="w-[50px]">
					@if (row.profile_consents != true) {
					<div class="w-4 h-4 bg-red-500 rounded-full m-auto"></div>
					} @else {
					<div class="w-4 h-4 bg-green-500 rounded-full m-auto"></div>
					}
				</td>
				}
				<!-- @if(row.last_update !== 0){
                @if(hasData('last_update')){
                <td nzAlign="center">{{row.last_update | date:'dd/MM/yyyy'}}</td>
                }
                } -->
				@if (hasData('last_update')) {
				@if (row.last_update) {
				<td nzAlign="center">
					{{ row.last_update | date: 'dd/MM/yyyy' }}
				</td>
				} @else {
				<td nzAlign="center">- -</td>
				}
				}

				@if (hasData('registered_at')) {
				<td nzAlign="center">
					{{ row.registered_at | date: 'dd/MM/yyyy' }}
				</td>
				}
				<!-- @if(!checkIfStrategyAreSameForAllClients())
                { -->
				@if (row.strategy == GeneralKonstants.Passpoint) {
				<td nzAlign="center">Passpoint</td>
				} @else {
				<td nzAlign="center">Captive Portal</td>
				}
				<!-- } -->
				<!-- @if(!checkIfLocationAreSameForAllClients()){
                <td>{{row._location}}</td>
                } -->
				@if (_verifiedCounters != 0) {
				<td>
					@if (row.verified != true) {
					<div class="w-4 h-4 bg-red-500 rounded-full m-auto"></div>
					} @else {
					<div class="w-4 h-4 bg-green-500 rounded-full m-auto"></div>
					}
				</td>
				}
				<!-- <td nzAlign="center">
                    <button
                        class="flex items-center bg-blue-300 hover:bg-blue-600 text-white font-bold py-2 px-2 rounded m-auto"
                        (click)="showSessionClient(row)">
                        <svg class="w-4 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                        </svg>
                    </button>
                </td> -->
				<td nzAlign="center">
					<!-- <button
						class="flex items-center bg-blue-300 hover:bg-blue-600 text-white font-bold py-2 px-2 rounded m-auto float-left"
						(click)="showSessionClient(row)">
						<svg class="w-4 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
						</svg>
					</button> -->
					<button class="flex items-center font-bold py-6 px-6 rounded m-full w-8 h-8 float-right expand_btn" nz-button
						nzSize="small" (click)="row.expand = !row.expand" (click)="showProfileFromIdentity(row)">
						<ng-container *ngIf="row.expand; else collapsed">
							<svg class="" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7">
								</path>
							</svg>
						</ng-container>
						<ng-template #collapsed>
							<svg class="" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
							</svg>
						</ng-template>
					</button>
				</td>
			</tr>
			<tr [nzExpand]="row.expand">
				@if (_deviceAccountsMode === 'passpoint') {
				<nz-table #innerTable [nzData]="_deviceAccounts" nzSize="middle" [nzShowPagination]="false"
					[nzScroll]="{x: '1500px'}">
					<thead>
						<tr>
							@if (hasDataDevice('username')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.username' | translate }}
							</th>
							}
							@if (hasDataDevice('channel')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.channel' | translate }}
							</th>
							}
							@if (hasDataDevice('identity_email')) {
							<th nzWidth="240px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.identity_email' | translate }}
							</th>
							}
							@if (hasDataDevice('status')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.status' | translate }}
							</th>
							}
							@if (hasDataDevice('created_at')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.created_at' | translate }}
							</th>
							}
							@if (hasDataDevice('last_update')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.last_update' | translate }}
							</th>
							}
							@if (hasDataDevice('valid_since')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.since' | translate }}
							</th>
							}
							@if (hasDataDevice('valid_until')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.until' | translate }}
							</th>
							}
							@if (hasDataDevice('os_version')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.os_version' | translate }}
							</th>
							}
							@if (hasDataDevice('mac')) {
							<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
								{{ 'table.mac' | translate }}
							</th>
							}
							<th nzWidth="200px">
								{{ 'table.show_sessions' | translate }}
							</th>
						</tr>
					</thead>
		<tbody>
			<tr *ngFor="let data of _deviceAccounts">
				@if (hasDataDevice('username')) {
				<td nz-tooltip="{{data.username}}">{{ data.username | truncateString:30 | replaceChar: '_' : ' ' }}</td>
				}
				@if (hasDataDevice('channel')) {
				<td>{{ data.channel | replaceChar: '_' : ' ' }}</td>
				}
				@if (hasDataDevice('identity_email')) {
				<td>{{ data.identity_email| replaceChar: '_' : ' ' }}</td>
				}
				@if (hasDataDevice('status')) {
				<td>
					@switch (data.status) {
					@case ('ACTIVE') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-green-500 rounded-full mr-2"></div>
						<span>{{ 'table.valid' | translate }}</span>
					</div>
					}
					@case ('DISABLED') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-red-500 rounded-full mr-2"></div>
						<span>{{ 'table.disabled' | translate }}</span>
					</div>
					}
					@case ('NOT_ACTIVE_YET') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-orange-500 rounded-full mr-2"></div>
						<span>{{ 'table.notActiveYet' | translate }}</span>
					</div>
					}
					@case ('EXPIRED') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-cyan-500 rounded-full mr-2"></div>
						<span>{{ 'table.expired' | translate }}</span>
					</div>
					}
					@default {
					Default case.
					}
					}
				</td>
				}
				@if (hasDataDevice('created_at')) {
				<td>{{ data.created_at | date: 'dd/MM/YYYY' }}</td>
				}
				@if (hasDataDevice('last_update')) {
				<td>{{ data.last_update | date: 'dd/MM/YYYY' }}</td>
				}
				@if (hasDataDevice('valid_since')) {
				<td>{{ data.valid_since | date: 'dd/MM/YYYY' }}</td>
				}
				@if (hasDataDevice('valid_until')) {
				<td>{{ data.valid_until | date: 'dd/MM/YYYY' }}</td>
				}
				@if (hasDataDevice('os_version')) {
				<td>{{ data.os_version }}</td>
				}
				@if (hasDataDevice('mac')) {
				<td>{{ data.mac }}</td>
				}
				@let popconfirmTitle = 'modal.popconfirmtitle' | translate;
				<td nzAlign="center" class="flex items-center justify-center space-x-2">

					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2 "
						(click)="goTo(data.username, 'sessions-page','', row.id)" nz-tooltip="Profile Details">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#000000"
							id="Address-Book-Tabs-Thin--Streamline-Phosphor-Thin" height="24" width="24">
							<desc>
								Address Book Tabs Thin Streamline Icon: https://streamlinehq.com
							</desc>
							<path
								d="M14.81739375 0.16H1.18260625C0.6178375 0.16 0.16 0.6178375 0.16 1.18260625v13.6347875c0 0.5647875 0.45781875 1.02263125 1.02260625 1.02260625h13.6347875c0.56475 -0.000025 1.02260625 -0.45785625 1.02260625 -1.02260625V1.18260625c0 -0.56475 -0.45785625 -1.02258125 -1.02260625 -1.02260625Zm-1.70435 5.4539125h2.04521875v4.772175h-2.04521875Zm2.04521875 -4.43130625v3.74956875h-2.04521875v-4.0904375h1.70435c0.18825625 0 0.34086875 0.1526125 0.34086875 0.34086875ZM0.8417375 14.81739375V1.18260625c0 -0.18825625 0.1526125 -0.34086875 0.34086875 -0.34086875h11.2487v14.316525H1.18260625c-0.18825625 0 -0.34086875 -0.1526125 -0.34086875 -0.34086875Zm13.97565625 0.34086875h-1.70435v-4.0904375h2.04521875v3.74956875c0 0.18825625 -0.1526125 0.34086875 -0.34086875 0.34086875Zm-5.123275 -3.83478125c-0.2456875 -0.9011875 -0.8860625 -1.64275 -1.74184375 -2.0171 1.5323125 -1.01286875 1.3935375 -3.30468125 -0.2497875 -4.12526875 -1.643325 -0.82058125 -3.55870625 0.44550625 -3.44769375 2.27895625 0.04534375 0.7487875 0.440175 1.43265625 1.06596875 1.8463125 -0.85515 0.3749625 -1.4950375 1.116325 -1.7409875 2.0171 -0.04691875 0.1821125 0.062525 0.367825 0.244575 0.41500625 0.0278 0.00739375 0.05645 0.01111875 0.0852125 0.011075 0.15534375 -0.0001125 0.29095625 -0.10524375 0.32979375 -0.25565 0.26673125 -1.02260625 1.2936 -1.7895625 2.39716875 -1.7895625s2.13469375 0.76695625 2.3963125 1.7895625c0.0656 0.25453125 0.3821375 0.34259375 0.5697625 0.15851875 0.08708125 -0.08543125 0.12196875 -0.210825 0.091525 -0.32895625Zm-4.76194375 -4.00521875c0 -1.3120125 1.4202875 -2.1320125 2.55651875 -1.4760125 1.1362375 0.65600625 1.1362375 2.29601875 0 2.95201875 -0.25909375 0.1495875 -0.55299375 0.2283375 -0.85216875 0.2283375 -0.9412875 0 -1.70435 -0.7630625 -1.70435 -1.70434375Z"
								stroke-width="0.0625"></path>
						</svg>
					</button>

					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2 "
						(click)="goTo(data.username, 'sessions','', row.id)" nz-tooltip="Sessions">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
							id="App-Window-Clock--Streamline-Ultimate" height="24" width="24">
							<desc>
								App Window Clock Streamline Icon: https://streamlinehq.com
							</desc>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M0.518 4.50391h20"
								stroke-width="1"></path>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								d="M8.518 16.5h-6c-0.53043 0 -1.03914 -0.2107 -1.41421 -0.5858C0.728713 15.5391 0.518 15.0304 0.518 14.5v-12c0 -0.53043 0.210713 -1.03914 0.58579 -1.41421C1.47886 0.710714 1.98757 0.5 2.518 0.5h16c0.5304 0 1.0391 0.210714 1.4142 0.58579 0.3751 0.37507 0.5858 0.88378 0.5858 1.41421V10"
								stroke-width="1"></path>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								d="M17.5 23.5c3.3137 0 6 -2.6863 6 -6s-2.6863 -6 -6 -6 -6 2.6863 -6 6 2.6863 6 6 6" stroke-width="1">
							</path>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M19.5 17.5h-2v-3"
								stroke-width="1"></path>
							<path stroke="#000000" d="M3.518 2.75391c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
								stroke-width="1"></path>
							<path stroke="#000000" d="M3.518 2.75391c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
								stroke-width="1"></path>
							<g>
								<path stroke="#000000" d="M5.518 2.75391c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
									stroke-width="1"></path>
								<path stroke="#000000" d="M5.518 2.75391c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
									stroke-width="1"></path>
							</g>
							<g>
								<path stroke="#000000" d="M7.518 2.75391c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
									stroke-width="1"></path>
								<path stroke="#000000" d="M7.518 2.75391c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
									stroke-width="1"></path>
							</g>
						</svg>
					</button>



					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2 "
						(click)="goTo(data.username, 'logs', '')" nz-tooltip="Logs">

						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="Common-File-Text-Clock--Streamline-Ultimate"
							height="24" width="24">
							<desc>
								Common File Text Clock Streamline Icon: https://streamlinehq.com
							</desc>
							<path d="m4.5 8.5 9.5 0" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								stroke-width="1"></path>
							<path d="m4.5 11.5 6 0" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								stroke-width="1"></path>
							<path d="m4.5 5.5 7 0" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								stroke-width="1"></path>
							<path d="m4.5 14.5 4 0" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								stroke-width="1"></path>
							<path d="m4.5 17.5 4 0" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								stroke-width="1"></path>
							<path
								d="M10.5 23.5h-9a1 1 0 0 1 -1 -1v-21a1 1 0 0 1 1 -1h13.293a1 1 0 0 1 0.707 0.293L19.207 4.5a1 1 0 0 1 0.293 0.707V8.5"
								fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
							<path d="M11.5 17.5a6 6 0 1 0 12 0 6 6 0 1 0 -12 0" fill="none" stroke="#000000" stroke-linecap="round"
								stroke-linejoin="round" stroke-width="1"></path>
							<path d="m19.5 17.5 -2 0 0 -3" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								stroke-width="1"></path>
						</svg>
					</button>

					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2" (click)="openUntilModal(data)"
						nz-tooltip="Expiry Date">
						<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" id="Time-Clock-Circle--Streamline-Ultimate"
							height="24" width="24">
							<desc>
								Time Clock Circle Streamline Icon: https://streamlinehq.com
							</desc>
							<path d="M0.499 12.001a11.5 11.5 0 1 0 23 0 11.5 11.5 0 1 0 -23 0" fill="none" stroke="#000000"
								stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
							<path d="m12 6.501 0 5.5 6 5.5" fill="none" stroke="#000000" stroke-linecap="round"
								stroke-linejoin="round" stroke-width="1"></path>
						</svg>
					</button>
					<!-- <button class="flex items-center bg-blue-300 hover:bg-blue-600 text-white font-bold py-2 px-2 rounded"
						(click)="showSessionClient(row)">
						<svg class="w-4 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
						</svg>
					</button> -->
					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2" (click)="
													prepareDisableDevice(data.username, _passpoint) 
												" nz-popconfirm nzPopconfirmTitle="{{ popconfirmTitle }}" (nzOnConfirm)="confirmDisable()"
						(nzOnCancel)="cancelDisable()" nz-tooltip="Disable Profile">

						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
							id="Single-Neutral-Actions-Remove--Streamline-Ultimate" height="24" width="24">
							<desc>
								Single Neutral Actions Remove Streamline Icon: https://streamlinehq.com
							</desc>
							<g>
								<g>
									<path d="M23.5 17.5a6 6 0 1 1 -6 -6 6 6 0 0 1 6 6" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
									<path d="m19.62 15.38 -4.24 4.24" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
									<path d="m19.62 19.62 -4.24 -4.24" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
								</g>
								<g>
									<path d="M3.25 4.75a4.25 4.25 0 1 0 8.5 0 4.25 4.25 0 1 0 -8.5 0" fill="none" stroke="#000000"
										stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
									<path d="M8.5 17.5h-8a7 7 0 0 1 10.78 -5.89" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
								</g>
							</g>
						</svg>
					</button>
				</td>
			</tr>
		</tbody>
	</nz-table>
	} @else if (_deviceAccountsMode === 'captive') {
	<nz-table #innerTable [nzData]="_captiveDeviceAccounts" nzSize="middle" [nzShowPagination]="false"
		[nzScroll]="{x: '1500px'}">
		<thead>
			<tr>
				@if (hasDataDevice('identity_email')) {
				<th nzWidth="240px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.identity_email' | translate }}
				</th>
				}
				@if (hasDataDevice('sponsor_email')) {
				<th nzWidth="240px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.sponsor_email' | translate }}
				</th>
				}
				@if (hasDataDevice('username')) {
				<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.username' | translate }}
				</th>
				}
				@if (hasDataDevice('strategy')) {
				<th nzWidth="180px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.strategy' | translate }}
				</th>
				}
				@if (hasDataDevice('status')) {
				<th nzWidth="180px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.status' | translate }}
				</th>
				}
				@if (hasDataDevice('created_at')) {
				<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.created_at' | translate }}
				</th>
				}
				@if (hasDataDevice('last_login')) {
				<th nzWidth="200px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.last_login' | translate }}
				</th>
				}
				<th nzWidth="150px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.expiration' | translate }}
				</th>
				<th nzWidth="120px" class="dark:bg-navy-800 dark:text-[#818cf8]">
					{{ 'table.actions' | translate }}
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let data of _captiveDeviceAccounts">
				@if (hasDataDevice('identity_email')) {
				<td>{{ data.identity_email }}</td>
				}
				@if (hasDataDevice('sponsor_email')) {
				<td>{{ data.sponsor_email }}</td>
				}
				@if (hasDataDevice('username')) {
				<td>
					<div class="flex items-center cursor-pointer " [nz-tooltip]="data.username">
						{{ data.username | truncateString:20}}
					</div>
				</td>
				}
				@if (hasDataDevice('strategy')) {
				<td>{{ data.strategy | replaceChar: '_' : ' ' }}</td>
				}
				@if (hasDataDevice('status')) {
				<td>
					@switch (data.status) {
					@case ('ACTIVE') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-green-500 rounded-full mr-2"></div>
						<span>{{ 'table.valid' | translate }}</span>
					</div>
					}
					@case ('DISABLED') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-red-500 rounded-full mr-2"></div>
						<span>{{ 'table.disabled' | translate }}</span>
					</div>
					}
					@case ('NOT_ACTIVE_YET') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-orange-500 rounded-full mr-2"></div>
						<span>{{ 'table.notActiveYet' | translate }}</span>
					</div>
					}
					@case ('EXPIRED') {
					<div class="flex items-center">
						<div class="w-4 h-4 bg-cyan-500 rounded-full mr-2"></div>
						<span>{{ 'table.expired' | translate }}</span>
					</div>
					}
					@default {
					Default case.
					}
					}
				</td>
				}
				@if (hasDataDevice('created_at')) {
				<td>{{ data.created_at | date: 'dd/MM/yyyy' }}</td>
				}
				@if (hasDataDevice('last_login')) {
				<td>{{ data.last_login | date: 'dd/MM/yyyy' }}</td>
				}
				<td>{{ data.valid ?? '-' }}</td>
				@let popconfirmTitle = 'modal.popconfirmtitle' | translate;

				<td nzAlign="center" class="flex items-center justify-center space-x-2">

					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2 "
						(click)="goTo(data.username, 'sessions-page', data.registration_location_id, row.id)"
						nz-tooltip="Profile Details">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#000000"
							id="Address-Book-Tabs-Thin--Streamline-Phosphor-Thin" height="24" width="24">
							<desc>
								Address Book Tabs Thin Streamline Icon: https://streamlinehq.com
							</desc>
							<path
								d="M14.81739375 0.16H1.18260625C0.6178375 0.16 0.16 0.6178375 0.16 1.18260625v13.6347875c0 0.5647875 0.45781875 1.02263125 1.02260625 1.02260625h13.6347875c0.56475 -0.000025 1.02260625 -0.45785625 1.02260625 -1.02260625V1.18260625c0 -0.56475 -0.45785625 -1.02258125 -1.02260625 -1.02260625Zm-1.70435 5.4539125h2.04521875v4.772175h-2.04521875Zm2.04521875 -4.43130625v3.74956875h-2.04521875v-4.0904375h1.70435c0.18825625 0 0.34086875 0.1526125 0.34086875 0.34086875ZM0.8417375 14.81739375V1.18260625c0 -0.18825625 0.1526125 -0.34086875 0.34086875 -0.34086875h11.2487v14.316525H1.18260625c-0.18825625 0 -0.34086875 -0.1526125 -0.34086875 -0.34086875Zm13.97565625 0.34086875h-1.70435v-4.0904375h2.04521875v3.74956875c0 0.18825625 -0.1526125 0.34086875 -0.34086875 0.34086875Zm-5.123275 -3.83478125c-0.2456875 -0.9011875 -0.8860625 -1.64275 -1.74184375 -2.0171 1.5323125 -1.01286875 1.3935375 -3.30468125 -0.2497875 -4.12526875 -1.643325 -0.82058125 -3.55870625 0.44550625 -3.44769375 2.27895625 0.04534375 0.7487875 0.440175 1.43265625 1.06596875 1.8463125 -0.85515 0.3749625 -1.4950375 1.116325 -1.7409875 2.0171 -0.04691875 0.1821125 0.062525 0.367825 0.244575 0.41500625 0.0278 0.00739375 0.05645 0.01111875 0.0852125 0.011075 0.15534375 -0.0001125 0.29095625 -0.10524375 0.32979375 -0.25565 0.26673125 -1.02260625 1.2936 -1.7895625 2.39716875 -1.7895625s2.13469375 0.76695625 2.3963125 1.7895625c0.0656 0.25453125 0.3821375 0.34259375 0.5697625 0.15851875 0.08708125 -0.08543125 0.12196875 -0.210825 0.091525 -0.32895625Zm-4.76194375 -4.00521875c0 -1.3120125 1.4202875 -2.1320125 2.55651875 -1.4760125 1.1362375 0.65600625 1.1362375 2.29601875 0 2.95201875 -0.25909375 0.1495875 -0.55299375 0.2283375 -0.85216875 0.2283375 -0.9412875 0 -1.70435 -0.7630625 -1.70435 -1.70434375Z"
								stroke-width="0.0625"></path>
						</svg>
					</button>

					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2 "
						(click)="goTo(data.username, 'sessions', data.registration_location_id, row.id)" nz-tooltip="Sessions">
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
							id="App-Window-Clock--Streamline-Ultimate" height="24" width="24">
							<desc>
								App Window Clock Streamline Icon: https://streamlinehq.com
							</desc>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M0.518 4.50391h20"
								stroke-width="1"></path>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								d="M8.518 16.5h-6c-0.53043 0 -1.03914 -0.2107 -1.41421 -0.5858C0.728713 15.5391 0.518 15.0304 0.518 14.5v-12c0 -0.53043 0.210713 -1.03914 0.58579 -1.41421C1.47886 0.710714 1.98757 0.5 2.518 0.5h16c0.5304 0 1.0391 0.210714 1.4142 0.58579 0.3751 0.37507 0.5858 0.88378 0.5858 1.41421V10"
								stroke-width="1"></path>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
								d="M17.5 23.5c3.3137 0 6 -2.6863 6 -6s-2.6863 -6 -6 -6 -6 2.6863 -6 6 2.6863 6 6 6" stroke-width="1">
							</path>
							<path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M19.5 17.5h-2v-3"
								stroke-width="1"></path>
							<path stroke="#000000" d="M3.518 2.75391c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
								stroke-width="1"></path>
							<path stroke="#000000" d="M3.518 2.75391c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
								stroke-width="1"></path>
							<g>
								<path stroke="#000000" d="M5.518 2.75391c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
									stroke-width="1"></path>
								<path stroke="#000000" d="M5.518 2.75391c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
									stroke-width="1"></path>
							</g>
							<g>
								<path stroke="#000000" d="M7.518 2.75391c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
									stroke-width="1"></path>
								<path stroke="#000000" d="M7.518 2.75391c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
									stroke-width="1"></path>
							</g>
						</svg>
					</button>



					<!-- <button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2 "
                        (click)="goTo(data.username, 'logs', data.registration_location_id)" nz-tooltip="Logs">
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                            id="Common-File-Text-Clock--Streamline-Ultimate" height="24" width="24">
                            <desc>
                                Common File Text Clock Streamline Icon: https://streamlinehq.com
                            </desc>
                            <path d="m4.5 8.5 9.5 0" fill="none" stroke="#000000" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1"></path>
                            <path d="m4.5 11.5 6 0" fill="none" stroke="#000000" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1"></path>
                            <path d="m4.5 5.5 7 0" fill="none" stroke="#000000" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1"></path>
                            <path d="m4.5 14.5 4 0" fill="none" stroke="#000000" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1"></path>
                            <path d="m4.5 17.5 4 0" fill="none" stroke="#000000" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1"></path>
                            <path
                                d="M10.5 23.5h-9a1 1 0 0 1 -1 -1v-21a1 1 0 0 1 1 -1h13.293a1 1 0 0 1 0.707 0.293L19.207 4.5a1 1 0 0 1 0.293 0.707V8.5"
                                fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="1"></path>
                            <path d="M11.5 17.5a6 6 0 1 0 12 0 6 6 0 1 0 -12 0" fill="none" stroke="#000000"
                                stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
                            <path d="m19.5 17.5 -2 0 0 -3" fill="none" stroke="#000000" stroke-linecap="round"
                                stroke-linejoin="round" stroke-width="1"></path>
                        </svg>
                    </button> -->

					<button class="flex rounded py-[6px] px-2 bg-white hover:bg-gray-600 border-2 "
						(click)="prepareDisableDevice(data.username, _captive)" nz-popconfirm
						nzPopconfirmTitle="{{ popconfirmTitle }}" (nzOnConfirm)="confirmDisable()" (nzOnCancel)="cancelDisable()"
						nz-tooltip="Disable Profile">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
							id="Single-Neutral-Actions-Remove--Streamline-Ultimate" height="24" width="24">
							<desc>
								Single Neutral Actions Remove Streamline Icon: https://streamlinehq.com
							</desc>
							<g>
								<g>
									<path d="M23.5 17.5a6 6 0 1 1 -6 -6 6 6 0 0 1 6 6" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
									<path d="m19.62 15.38 -4.24 4.24" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
									<path d="m19.62 19.62 -4.24 -4.24" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
								</g>
								<g>
									<path d="M3.25 4.75a4.25 4.25 0 1 0 8.5 0 4.25 4.25 0 1 0 -8.5 0" fill="none" stroke="#000000"
										stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
									<path d="M8.5 17.5h-8a7 7 0 0 1 10.78 -5.89" fill="none" stroke="#000000" stroke-linecap="round"
										stroke-linejoin="round" stroke-width="1"></path>
								</g>
							</g>
						</svg>
					</button>
				</td>
			</tr>
		</tbody>
	</nz-table>
	}
	</tr>
	} @empty {
	<tr class="dark:bg-navy-800 dark:text-[#818cf8]">
		<td colspan="8" class="dark:border-navy-700">
			<nz-empty [nzNotFoundContent]="contentTpl">
				<ng-template #contentTpl>
					<span> {{ 'table.noData' | translate }} </span>
				</ng-template>
			</nz-empty>
		</td>
	</tr>
	}
	</tbody>
	</nz-table>
</div>

@let modTitle = 'modal.changeUntil' | translate;
<nz-modal [(nzVisible)]="_isVisibleUntilModal" nzTitle="{{ modTitle }}" (nzOnCancel)="handleCancelUntilModal()"
	(nzOnOk)="handleOkUntilModal()">
	<ng-container *nzModalContent>
		<nz-row class="text-center">
			<nz-col nzSpan="24">
				<nz-date-picker [(ngModel)]="identityDateUntil" (ngModelChange)="onChangeUntildate($event)"></nz-date-picker>
			</nz-col>
		</nz-row>
	</ng-container>
</nz-modal>